import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useAuth, useUser } from "@clerk/clerk-react";
import { setUser } from "../Actions/authAction";
import { useEffect } from "react";
import { setTokenFetcher } from "./API";

export const AppRoute = ({ component: Component, layout: Layout, ...rest }) => {
  Layout = Layout === undefined ? (props) => <>{props.children}</> : Layout;

  return (
    <Route
      {...rest}
      render={(props) => (
        <Layout>
          <Component {...props} />
        </Layout>
      )}
    />
  );
};

export const PrivateRoute = ({ component: Component, ...rest }) => {
  const dispatch = useDispatch();
  const { isLoaded, isSignedIn, getToken } = useAuth();
  const { user } = useUser();

  useEffect(() => {
    if (isLoaded && isSignedIn) {
      setTokenFetcher(getToken);
    }
  }, [isLoaded, isSignedIn, getToken]);

  useEffect(() => {
    const initAuth = async () => {
      if (isLoaded && isSignedIn && user) {
        const mappedUser = {
          ...user,
          name: user.fullName || user.username || (user.primaryEmailAddress ? user.primaryEmailAddress.emailAddress : ""),
          email: user.primaryEmailAddress ? user.primaryEmailAddress.emailAddress : "",
          picture: user.imageUrl || "",
        };
        dispatch(setUser({ user: mappedUser, isAuthenticated: true }));
        const token = await getToken();
        if (token) {
          localStorage.setItem("access_token", token);
        }
      }
    };
    initAuth();
  }, [isLoaded, isSignedIn, user, dispatch, getToken]);

  if (!isLoaded) {
    return null; // app.js loading spinner handles this, but avoids flashing/redirects
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        isSignedIn ? <Component {...props} /> : <Redirect to="/admin" />
      }
    />
  );
};
